<template>
    <div>
        <filter-default v-model="filters" v-bind:options="options" requests>
            <div class="column is-narrow pt-1 pb-1">
                <div class="flatpickr-combined">
                    <async-select
                        api="ports"
                        placeholder="Abfahrtshafen"
                        v-model="filters.ferry.startPort"
                        v-bind:custom-label="port => port.place.name"
                        class="is-smaller"
                    />

                    <span>-</span>

                    <async-select
                        api="ports"
                        placeholder="Ankunftshafen"
                        v-model="filters.ferry.endPort"
                        v-bind:custom-label="port => port.place.name"
                        class="is-smaller"
                    />
                </div>
            </div>
        </filter-default>
    </div>
</template>

<script>
import value, { options } from '../_mixins';
import FilterDefault from '../Default';
import { AsyncSelect } from '@components/form'

export default {
    mixins: [ value, options ],

    components: {
        FilterDefault,
        AsyncSelect
    }
}
</script>
